import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";
import Button from "./Button";
import { color } from "../../styles/theme";

/**
 * Shown in place of a page's content when a logged-in Sub-Account lacks the
 * permission block that page requires (Promoter Panel spec ch.11.2) — used
 * by AppRoutes.jsx's ProtectedRoute via its `requiredPermission` prop.
 */
const AccessDenied = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  return (
    <div style={s.wrap}>
      <span style={s.iconBadge}><Lock size={22} strokeWidth={1.75} /></span>
      <h2 style={s.title}>{t("accessDenied.title")}</h2>
      <p style={s.message}>{t("accessDenied.message")}</p>
      <Button onClick={() => navigate("/dashboard")}>{t("accessDenied.backToDashboard")}</Button>
    </div>
  );
};

const s = {
  wrap: { display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", padding: "60px 24px", maxWidth: 420, margin: "0 auto" },
  iconBadge: {
    width: 48, height: 48, borderRadius: "50%", background: color.gray100, color: color.gray600,
    display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16,
  },
  title: { margin: "0 0 8px", fontSize: 17, fontWeight: 700, color: color.textPrimary },
  message: { margin: "0 0 20px", fontSize: 13.5, color: color.textSecondary, lineHeight: 1.6 },
};

export default AccessDenied;
